import { Button } from "@portal/BaseComponents/Button/AntButton";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { Popover } from "@portal/BaseComponents/PopOver/AntPopOver";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import useDownloadDocument from "@portal/hooks/useDownlodDocument";
import { Icon } from "@portal/lib/icons/icons";
import { StatementTypes } from "@portal/types/entities/statement";
import { FileType } from "@portal/types/file";
import { useState } from "react";
import { OutStandingTransactions } from "../OutstandingTransactions";
import { StatementContentProps } from "../type";

export interface DownloadStatementFilter {
  transaction_type: StatementTypes;
  file_type: FileType;
  date?: string;
  from?: string;
  to?: string;
}
export const t = {
  statement: "Statement",
  as_of: "as of",
  download: "Download",
  month_range: "Month Range",
  download_statement: "Download Statement",
  desc: "This report contains receivables data of the customer.",
  notify: {
    success: "Successfully generated statement!",
    failure: "Something went wrong!",
  },
  all_transactions: "All Transactions",
  outstanding_transactions: "Outstanding Transactions",
};

export const DownloadIcon = (
  <Icon icon={["far", "arrow-to-bottom"]} color="var(--primary-7)" />
);

export const SuffixIcon = (
  <Icon icon={["far", "chevron-down"]} color="var(--gray-1)" />
);

const CloseIcon = <Icon icon={["fal", "times"]} color="var(--gray-8)" />;

// export const stateMentOptions: GenericRadioOptions<StatementTypes> = [
//   {
//     label: t.outstanding_transactions,
//     value: "OUTSTANDING",
//     style: { borderRadius: "var(--br-1) 0 0 var(--br-1)" },
//   },
//   {
//     label: t.all_transactions,
//     value: "ALL",
//     style: { borderRadius: "0 var(--br-1) var(--br-1)  0" },
//   },
// ];
function StatementContent(props: Readonly<StatementContentProps>) {
  const { id, children, open, onClose, handlePopupContainer } = props;

  const [statementType] = useState<StatementTypes>("OUTSTANDING");
  const { downloadCallback } = useDownloadDocument(
    t.notify.success,
    t.notify.failure
  );

  const isOutstanding = statementType === "OUTSTANDING";

  // function handleOnChange(event: RadioChangeEvent) {
  //   event.stopPropagation();
  //   setStatementType(event.target.value);
  // }

  // const StatementOption = (
  //   <RadioGroup
  //     optionType="button"
  //     options={stateMentOptions}
  //     defaultValue={"ALL"}
  //     value={statementType}
  //     onChange={handleOnChange}
  //   />
  // );

  const PopOverHeader = (
    <Flex align="center" justify="space-between" style={{ width: "100%" }}>
      <TypographyText fs="16" strong>
        {t.download_statement}
      </TypographyText>
      <Button size="small" icon={CloseIcon} onClick={onClose} />
    </Flex>
  );

  const Title = (
    <TypographyText>{isOutstanding ? null : t.month_range}</TypographyText>
  );
  const DatePicker = (
    <OutStandingTransactions
      customerId={id}
      download={downloadCallback}
      onClose={onClose}
      url="v1/customers/download-statement"
    />
  );
  const PopOverContent = (
    <Flex
      style={{ padding: "var(--space-24) var(--space-20)", width: "100%" }}
      vertical
      space="16"
    >
      {PopOverHeader}
      {/* {StatementOption} */}
      <Flex vertical align="start" space="4">
        {Title}
        {DatePicker}
      </Flex>
    </Flex>
  );
  return (
    <Popover
      content={PopOverContent}
      trigger={["click"]}
      overlayStyle={{ width: 390 }}
      open={open}
      placement="bottomLeft"
      getPopupContainer={handlePopupContainer}
      overlayInnerStyle={{
        borderRadius: "var(--br-1)",
        boxShadow: "var(--shadow-3)",
        padding: 0,
      }}
      destroyTooltipOnHide
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      {children}
    </Popover>
  );
}

export { StatementContent };
